<template>
  <div class="aMap">
    <div class="map" id="map"></div>
    <!--v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)"-->
    <!-- <div class="point"> -->
    <!-- <i class="el-icon-location"></i>
      当前显示范围：
      <el-switch
        v-model="selectId"
        active-color="rgba(170, 253, 254, .5)"
        inactive-color="rgba(255, 255, 255, .5)"
        :inactive-value="1"
        :active-value="440000"
        active-text="广东省"
        inactive-text="全国">
      </el-switch> -->
    <!--<ElementSelect :val="selectId"-->
    <!--               :options="selectList"-->
    <!--               :transfer="false"-->
    <!--               @change="changeSelect" />-->
    <!-- </div> -->
    <!-- <div class="map-radio-box">
      <div class="name">
        <span></span>
      </div> -->
    <!-- <el-cascader
        v-model="mapTabIndex"
        :placeholder="'请选择地图渲染对象'"
        :options="options"
        @change="handleChange"
        :show-all-levels="false"
      ></el-cascader> -->
    <!-- <ElementSelect
        :val="year"
        @val="
          (e) => {
            year = e;
          }
        "
        :options="options"
      /> -->
    <!-- </div> -->
    <!-- <div class="map-color-box">
      <div class="num-box">
        <span>{{ selectId > 1 ? countGuangdong : count }}</span>
        <span>{{ selectId > 1 ? cityMinNum : minNum }}</span>
      </div>
      <div class="map-color"></div>
    </div> -->
    <div v-if="itemData.city" class="info-box">
      <i :class="'icon' + mapIconIndex"></i>
      <h1>
        {{ itemData.city }}<span>数据时间：{{ linkParams.year }}年</span>
      </h1>
      <template v-if="itemData.list">
        <div class="num-box" v-for="item in itemData.list">
          <div class="label">{{ item.label }}：</div>
          <div class="num">{{ item.value }}</div>
          <span>{{ item.unit }}</span>
        </div>
      </template>
      <div v-else class="num-box">
        <div class="num">{{ itemData.num }}</div>
        <span>户</span>
      </div>
    </div>
    <!--<transition name="el-fade-in">-->
    <div
      class="map-loading"
      v-loading="loading"
      v-if="loading"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    ></div>
    <!--</transition>-->
  </div>
</template>

<script>
import ElementSelect from '../../../components/element-select';
import { getMapData } from '../../../api/getMapData';
import GisInfoBox from '../../../components/map/GisInfoBox';

export default {
  name: 'GzMap',
  components: { ElementSelect },
  props: {
    linkParams: {
      type: Object,
      default: {},
    },
  },
  data() {
    return {
      mapIcon:
        'data:image/png;base64,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',
      mapIcon2:
        'data:image/png;base64,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',

      selectId: 440000,
      selectList: [
        {
          value: 1,
          label: '全国',
        },
        {
          value: 440000,
          label: '广东省',
        },
      ],
      proCenter: [113.28, 23.125],
      loading: false,
      map: null,
      AMap: null,
      valData: {},
      maxNum: 0,
      minNum: 0,
      count: null,
      cityValData: {},
      cityMaxNum: 0,
      cityMinNum: 0,
      countGuangdong: null,
      mapObj: {
        disCity: [],
      },
      itemData: {},
      typeId: 1,
      // 全国企业500强
      countryQuotaData: {},
      // 广东企业500强
      cityQuotaData: {},
      mapTabIndex: [1],
      options: [
        {
          label: '市场主体基本情况',
          value: 1,
          children: [
            {
              label: '累计总数',
              value: 11,
              children: [
                {
                  label: '市场主体地市分布情况',
                  value: 111,
                },
                {
                  label: '主体类型类型统计',
                  value: 112,
                  children: [
                    {
                      label: '私营企业',
                      value: 1121,
                    },
                    {
                      label: '个体工商户',
                      value: 1122,
                    },
                  ],
                },
                {
                  label: '主体类型行业与产业统计',
                  value: 113,
                  children: [
                    {
                      label: '行业',
                      value: 1131,
                      children: [
                        {
                          label: '制造业',
                          value: 11311,
                        },
                        {
                          label: '服务业',
                          value: 11312,
                        },
                      ],
                    },
                    {
                      label: '产业',
                      value: 1132,
                      children: [
                        {
                          label: '第一产业',
                          value: 11321,
                        },
                        {
                          label: '第二产业',
                          value: 11322,
                        },
                        {
                          label: '第三产业',
                          value: 11323,
                        },
                      ],
                    },
                  ],
                },
              ],
            },
            {
              label: '本年新增',
              value: 12,
              children: [
                {
                  label: '市场主体地市分布情况',
                  value: 121,
                },
                {
                  label: '市场主体类型统计',
                  value: 122,
                },
                {
                  label: '市场主体行业与产业统计',
                  value: 123,
                },
              ],
            },
            {
              label: '广东省科创企业地市分布',
              value: 13,
            },
            {
              label: '广东省百强企业地市分布',
              value: 14,
            },
          ],
        },
      ],
      mapData: [],
      mapIconIndex: 1,
    };
  },
  watch: {
    selectId(n) {
      // this.getData();
      this.showProvince();
      this.$emit('mapCode', {
        code: n,
      });
    },
    linkParams(n) {
      console.log(n, '-n');
      this.mapTabIndex = [n.index];
      this.handleChange();
    },
    itemData(n) {
      console.log(n, '-itemData');
    },
    loading(n) {
      this.$emit('loading', n);
    },
  },
  computed: {
    isGuangdong() {
      return this.selectId === 440000;
    },
  },
  methods: {
    handleChange() {
      let tmp = this.mapTabIndex.slice(-1)[0];
      this.mapIconIndex = tmp;
      switch (tmp) {
        case 111:
        case 121:
          this.mapIconIndex = 4;
          this.$api.market
            .getScztqkDistribution({
              dataType: tmp === 111 ? 1 : 2,
              year: this.linkParams.year,
            })
            .then((res) => {
              let { data } = res.data.data;
              this.mapData = data.map((x) => ({
                city: x.new_city,
                num: x.num,
              }));
              this.afterGetData();
              // this.mapData.max = data.reduce((max, obj) => Math.max(max, obj.num), data[0].num);
              // this.mapData.min = data.reduce((min, obj) => Math.min(min, obj.num), data[0].num);
            });

          break;
        case 1:
          // 各市科创企业情况
          this.$api.market.getEntData(this.linkParams).then((res) => {
            let { data } = res.data;
            this.mapData = data.list.map((x) => ({
              city: x.city + '市',
              num: x.count,
            }));
            this.afterGetData();
          });
          break;
        case 2:
          // 各市科技经费投入情况
          this.$api.market
            .getKjjfCity({
              year: this.linkParams.year,
            })
            .then((res) => {
              let { data } = res.data;
              let listData = [];
              if (data && data.funds?.length) {
                data.funds.map((x) => {
                  let t1 = x.city.replace(/\s+/g, '');
                  let tmp = data.porportion.find((y) => {
                    let t2 = y.city.replace(/\s+/g, '');
                    let tmp2 = listData.find((z) => z.city === t1);
                    return tmp2 ? false : t1 === t2;
                  });
                  if (tmp)
                    listData.push({
                      city: t1 + '市',
                      list: [
                        {
                          label: 'R&D经费',
                          value: x.funds,
                          unit: '亿元',
                        },
                        {
                          label: 'R&D经费占地区生产总值',
                          value: tmp.proportion,
                          unit: '',
                        },
                      ],
                    });
                });
              }
              this.mapData = listData;
              this.afterGetData();
            });
          break;
        case 3:
          //各市专利授权情况
          this.$api.market
            .getZlsqCity({
              year: this.linkParams.year,
            })
            .then((res) => {
              let { data } = res.data;
              let listData = [];
              if (data && data.invent?.length) {
                data.invent.map((x) => {
                  let tmp = data.design.find((y) => y.city === x.city),
                    tmp2 = data.utility.find((y) => y.city === x.city),
                    tmp3 = listData.find((y) => y.city === x.city);
                  if (!tmp3) {
                    listData.push({
                      city: x.city + '市',
                      list: [
                        {
                          label: '发明',
                          value: x.invent,
                          unit: '件',
                        },
                        {
                          label: '实用新型',
                          value: tmp2.utility,
                          unit: '件',
                        },
                        {
                          label: '外观设计',
                          value: tmp.design,
                          unit: '件',
                        },
                      ],
                    });
                  }
                });
              }
              this.mapData = listData;
              this.afterGetData();
            });
          break;
        case 4:
          break;
        default:
          break;
      }
    },
    afterGetData() {
      this.updateLabel(this.mapData[0].city);
    },
    changeSelect(e) {
      this.selectId = e;
    },
    showProvince() {
      let { map, AMap } = this;
      this.loading = true;
      let {
        disCountry,
        disProvince,
        disProGuangDong,
        disCity,
        layerProvince,
        layerCity,
        focusProvince,
        polygonCity,
        label,
      } = this.mapObj;

      // disCountry.hide();
      // disProvince.hide();
      disCountry && disCountry.setMap(null);
      disProvince && disProvince.setMap(null);
      disProGuangDong && disProGuangDong.setMap(null);
      focusProvince.setDistricts('');
      focusProvince.setMap(map);
      map.remove(disProvince);
      label?.hide();
      if (disCity) {
        disCity.map((item) => {
          item.hide();
        });
      }
      if (polygonCity) {
        map.remove(polygonCity); //清除上次结果
        polygonCity = null;
      }
      if (this.selectId > 1) {
        layerProvince.hide();
        layerCity.show();
        this.getProvinceMap();
        let pos = [this.proCenter[0] + 0.05, this.proCenter[1] - 0.5];
        map?.setCenter(pos, false, 50);
        map?.setZoom(7.4);
      } else {
        layerCity.hide();
        layerProvince.show();
        this.getCountryMap();
        map?.setCenter([104.122082, 36.719192], false, 50);
        map.setZoom(4.5);
      }
      // map.setFitView();
      this.mapListen();

      setTimeout(() => {
        this.loading = false;
      }, 1500);
    },
    getColorByVal(name, focus, city) {
      var colors = {};
      let max = city ? this.cityMaxNum : this.maxNum,
        min = city ? this.cityMinNum : this.minNum;

      let r = 73,
        g = 243,
        b = 243;
      let colorArr = [
        {
          r: 0,
          g: 120,
          b: 255,
          a: 0.3,
        },
        {
          r: 0,
          g: 201,
          b: 255,
        },
        {
          r: 88,
          g: 236,
          b: 172,
        },
        {
          r: 252,
          g: 245,
          b: 194,
        },
      ];
      let a = null;

      if (city) {
        name = name.replace('区', '');
      }
      if (!colors[name]) {
        var val = city ? this.cityValData[name] : this.valData[name];
        if (city && this.typeId === 2) {
          let valObj = {};
          this.cityQuotaData.map((item) => {
            valObj[item.cityName] = item.total;
          });
          let arr = this.cityQuotaData.map((item) => item.total);
          arr = arr.sort(function (a, b) {
            return a - b;
          });

          max = arr[arr.length - 1];
          min = arr[0];
          val = valObj[name + '区'];
          console.log(max, min, valObj, val, name);
        }
        if (!val) {
          colors[name] = 'rgba(27, 95, 152, .5)';
          // colors[adcode] = 'rgba(73, 243, 243, .75)'
        } else {
          let pro = val / max;
          if (val === min) {
            let { r, g, b } = colorArr[0];
            a = 0.8;
            colors[name] = 'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
          } else if (pro <= 0.36) {
            let { r, g, b } = colorArr[1];
            a = (val / (max * 0.36)) * 0.8;
            // a = val / ( max * 0.36 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          } else if (pro <= 0.71) {
            let { r, g, b } = colorArr[2];
            a = (val / (max * 0.71)) * 0.8;
            // a = val / ( max * 0.71 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          } else if (pro <= 1) {
            let { r, g, b } = colorArr[3];
            a = (val / max) * 0.8;
            // a = val / ( max * 0.8 * 0.8 ) * 0.5;
            a < 0.3 ? (a = 0.3) : '';
            colors[name] = 'rgb(' + r + ',' + g + ',' + b + ')';
          }
          // a = val / max * 0.75;
          // colors[name] =
          //   // val !== max ?
          //   val <= min ?
          //     'rgba(27, 95, 152, .5)' :
          //     'rgba(' + r + ',' + g + ',' + b + ',' + a + ')';
        }
      }
      // a ? a = Math.round(a.toFixed(2) * 100) / 100 : ''
      if (focus) {
        colors[name] = 'rgba(231, 223, 180, .8)';
      }
      return city ? [colors[name], a ? a : '.3'] : colors[name];
    },
    getData() {
      this.$api.screen.getGdMembersData().then((res) => {
        let { data } = res.data;
        let dataObj = {};
        data.map((item) => {
          dataObj[item.name] = item.membersTotal;
        });
        this.cityValData = dataObj;
        let arr = [];
        for (let key in dataObj) {
          arr.push(dataObj[key]);
        }
        arr = arr.sort(function (a, b) {
          return a - b;
        });

        let max = arr[arr.length - 1],
          min = arr[0];
        this.cityMaxNum = max;
        this.cityMinNum = min;
      });

      this.$api.screen.getMapCountryEnQuota().then((res) => {
        this.countryQuotaData = res.data.data;
      });

      this.$api.screen.getMapCityEnQuota().then((res) => {
        this.cityQuotaData = res.data.data;
      });
    },
    getCountryMap() {
      var disCountry = new AMap.DistrictLayer.Country({
        zIndex: 1,
        SOC: 'CHN',
        depth: 1,
        styles: {
          'nation-stroke': 'rgb(67, 242, 243)',
          'coastline-stroke': 'rgb(67, 242, 243)',
          'province-stroke': 'rgba(0, 0, 0, 0)',
          'stroke-width': 4,
          fill: function (props) {
            return 'rgba(27, 95, 152, .6)';
            // return "rgba(0, 0, 0, .1)"
          },
        },
      });
      let proOptions = {
        zIndex: 20,
        depth: 0,
        styles: {
          'province-stroke': '#49f3f3',
          'stroke-width': 1,
          fill: (props) => {
            return '';
            // return this.getColorByVal(props.NAME_CHN)
          },
        },
      };
      let disProvince = new AMap.DistrictLayer.Province(proOptions);
      this.mapObj.disCountry = disCountry;
      this.mapObj.disProvince = disProvince;
      this.mapObj.proOptions = proOptions;
      // this.map ? this.mapObj.disCountry.setMap(this.map) : '';
      // this.map ? this.mapObj.disProvince.setMap(this.map) : '';
    },
    getProvinceMap() {
      let { disCity } = this.mapObj;
      let disProGuangDong = new AMap.DistrictLayer.Province({
        adcode: '440000',
        zIndex: 20,
        depth: 1,
        zoom: 10,
        styles: {
          'province-stroke': '#bce9fb',
          'stroke-width': (props) => {
            if (props.adcode_pro === 440000) {
              if (props.level === 'province') return 8;
              else return 2;
            } else return 0;
          },
          'city-stroke': '#bce9fb',
          fill: (props) => {
            //   return 'rgba(27, 95, 152, .67)';
            return 'rgba(189, 239, 255, 0.18)';
          },
        },
      });
      let disProGuangDongShadow = new AMap.DistrictLayer.Province({
        adcode: '440000',
        zIndex: 1,
        depth: 1,
        zoom: 10,
        styles: {
          'province-stroke': 'rgba(0, 0, 0, 0)',
          'stroke-width': (props) => {
            if (props.adcode_pro === 440000) {
              if (props.level === 'province') return 18;
              else return 0;
            } else return 0;
          },
          'city-stroke': 'rgba(0, 0, 0, 0.67)',
          fill: (props) => {
            // return 'url(~img/commonImg/map_bg.jpg)';
            return 'rgba(0, 0, 0, 0.67)';
            // return this.getColorByVal(props.NAME_CHN, false, true);
          },
        },
      });
      // disProGuangDong.setMap(this.map);
      // disProGuangDong.hide();
      this.mapObj.disProGuangDong = disProGuangDong;
      this.mapObj.disProGuangDongShadow = disProGuangDongShadow;
      console.log(disCity, 89);
      if (disCity?.length) {
        disCity.map((item) => {
          item.show();
        });
      }
    },
    getProvinceFocus() {
      let focusProvince = new AMap.DistrictLayer.Province({
        zIndex: 29,
        depth: 0,
        styles: {
          'province-stroke': '#49f3f3',
          'stroke-width': 1,
          fill: (props) => {
            return this.getColorByVal(props.NAME_CHN, true);
          },
        },
      });
      this.mapObj.focusProvince = focusProvince;
      focusProvince.show();
    },
    getLabelsData() {
      let { AMap, map } = this;
      let provinceData = [],
        cityData = [];

      var districtSearch = new AMap.DistrictSearch({
        // adcode: 440000,
        level: 'biz_area',
        extensions: 'all',
        subdistrict: 3, //  显示下级行政区级数
      });

      districtSearch.search('440000', (status, result) => {
        if (status == 'complete') {
          cityData = result.districtList[0].districtList;
          this.mapObj.cityData = [...cityData];
        }
      });
    },
    async initMap() {
      // AMap 对象
      this.AMap = window.AMap;

      this.getProvinceMap();
      this.getLabelsData();
      let { disProGuangDong } = this.mapObj;
      var districtSearch = new AMap.DistrictSearch({
        // adcode: 440000,
        level: 'biz_area',
        extensions: 'all',
        subdistrict: 3, //  显示下级行政区级数
      });
      var mask = [],
        disCity = [];
      districtSearch.search('440000', (status, result) => {
        // this.handleChange();
        var bounds = result.districtList[0].boundaries;
        for (var i = 0; i < bounds.length; i += 1) {
          mask.push([bounds[i]]);
        }

        const imageLayer = new AMap.ImageLayer({
          // url: '../../../assets/commonImg/map_bg.jpg',
          // url: 'http://localhost:8080/static/img/map_bg.4151cf6e.jpg',
          url: 'http://wsgsldp.gdgcc.gov.cn/static/img/map_bg.4151cf6e.jpg',
          bounds: new AMap.Bounds([109, 20], [118, 26]),
          zooms: [4, 10],
        });
        var map = new AMap.Map('map', {
          zooms: [4, 10],
          center: [113.6, 23.4],
          zoom: 7.5,
          isHotspot: false,
          defaultCursor: 'pointer',
          viewMode: '3D',
          features: [],
          mask,
          // resizeEnable: false,
          // dragEnable: false,
          // zoomEnable: false,
          // scrollWheel: false,
          // touchZoom: false,
          // mask: mask,
          layers: [
            disProGuangDong,
            // disProGuangDongShadow,
            // disProvince,
            // defaultLayer
            // new AMap.TileLayer.Satellite(),
            imageLayer,
          ],
          viewMode: '2D',
        });
        disProGuangDong.setMap(map);
        this.map = map;
        var layer = new AMap.LabelsLayer({
          // 开启标注避让，默认为开启，v1.4.15 新增属性
          collision: false,
          // 开启标注淡入动画，默认为开启，v1.4.15 新增属性
          animation: true,
        });
        this.mapObj.labelsMarker = [];
        this.mapObj.districtList = result.districtList[0].districtList;
        this.mapObj.layer = layer;
        this.setLabel();
        map.on('mousemove', (ev) => {
          var px = ev.pixel;
          // 拾取所在位置的行政区
          var props = disProGuangDong.getDistrictByContainerPos(px);

          if (props) {
            var SOC = props.NAME_CHN;

            if (SOC && this.mapObj.selectCity !== SOC) {
              this.updateLabel(SOC);
            }
          }
        });
        map.add(layer);
      });

      document.getElementsByClassName('amap-mcode')[0].innerHTML = '';
      this.$nextTick(() => {
        this.mapListen();
      });
    },
    setLabel() {
      let { districtList, layer } = this.mapObj;
      districtList.map((x, i) => {
        const labelsMarker = new AMap.LabelMarker({
          position: x.center,
          icon: {
            image: this.mapIcon,
            size: [85, 39],
            offset: [0, -30],
          },
          text: {
            content: x.name,
            style: {
              fontSize: 15,
              fillColor: '#F0F0F0',
            },
          },
        });
        this.mapObj.labelsMarker.push(labelsMarker);
        layer.add(labelsMarker);
      });
    },
    updateLabel(SOC) {
      let { disProGuangDong, labelsMarker, selectCity } = this.mapObj;
      // 重置行政区样式
      disProGuangDong.setStyles({
        'province-stroke': '#bce9fb',
        'stroke-width': (props) => {
          if (props.adcode_pro === 440000) {
            if (props.level === 'province') return 8;
            else return 2;
          } else return 0;
        },
        'city-stroke': '#bce9fb',
        fill: function (props) {
          // console.log(props.NAME_CHN, SOC);
          return props.NAME_CHN == SOC ? 'rgba(212, 193, 101, 0.4)' : 'rgba(189, 239, 255, 0.18)';
        },
      });
      labelsMarker.find((a) => {
        // console.log(selectCity, SOC);
        if (a._opts.text.content === selectCity) {
          a.setIcon({
            image: this.mapIcon,
          });
        }
        if (a._opts.text.content === SOC) {
          a.setIcon({
            image: this.mapIcon2,
          });
        }
      });
      this.mapObj.selectCity = SOC;
      // layer.add(labelsMarker);

      this.itemData = this.mapData.find((y) => y.city === SOC);
      //   // updateInfo(props);
    },
    setLabels(adcode = '', city) {
      let { map, AMap } = this;
      let { layerProvince, provinceData, layerCity, cityData, disCity, label } = this.mapObj;
      console.log(this.mapObj);
      let isSelected = false;
      let labelObj = {
          position: [],
          text: {
            content: '',
            direction: 'center',
            style: {
              fillColor: '#fff',
              strokeColor: 'rgba(255, 255, 255, .1)',
            },
          },
          icon: {
            image:
              'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFUA…Ct8B4B8CLfs0EJ74SqP8Fg0G++gpEZdoAAAAASUVORK5CYII=',
          },
        },
        selectStyle = {
          fillColor: '#000',
          strokeColor: 'rgba(255, 255, 255, .1)',
        };

      if (layerProvince) {
        map.remove(layerProvince);
      }
      if (layerCity) {
        map.remove(layerCity);
      }

      layerProvince = new AMap.LabelsLayer({
        collision: false, // 开启标注避让
        animation: true, // 开启标注淡入动画
      });
      this.mapObj.layerProvince = layerProvince;
      layerCity = new AMap.LabelsLayer({
        collision: false, // 开启标注避让
        animation: true, // 开启标注淡入动画
      });
      this.mapObj.layerCity = layerCity;

      // console.log(label, 123123123123123123123);
      // 选中文字样式
      if (!label) {
        label = new AMap.LabelMarker({
          ...labelObj,
          text: {
            direction: 'center',
            style: selectStyle,
          },
        });
        map.add(label);
        this.mapObj.label = label;
        // label.hide();
      }

      // for (let i = 0; i < cityData?.length; i++) {
      //   isSelected = adcode && adcode == cityData[i].adcode;
      //   // !cityData?.length && provinceData[i].name === '广州市'
      //   //   ? (cityData = JSON.parse(JSON.stringify(provinceData[i].districtList)))
      //   //   : [];

      //   let data = cityData[i];
      //   let boxHtml = this.$u.createElm('div');
      //   boxHtml.appendChild(
      //     this.$u.drawDialog(GisInfoBox, {
      //       cityName: data.name,
      //       type: 1,
      //       dataObj: this.countryQuotaData,
      //     }),
      //   );
      //   let infoWindow = new AMap.InfoWindow({
      //     isCustom: true, //使用自定义窗体
      //     content: boxHtml,
      //     offset: new AMap.Pixel(0, -10),
      //   });
      //   infoWindow.off('mouseover').on('mouseover', (e) => {
      //     let center = [data.center.lng, data.center.lat];
      //     infoWindow.open(map, center);
      //   });

      //   infoWindow.off('mouseout').on('mouseout', (e) => {
      //     infoWindow.close();
      //   });

      //   let obj = {
      //     ...labelObj,
      //     position: [cityData[i].center.lng, cityData[i].center.lat],
      //   };
      //   obj.text.content = cityData[i].name;
      //   if (isSelected && adcode !== 440000) {
      //     label.setPosition(obj.position);
      //     label.setText({
      //       content: obj.text.content,
      //     });
      //     label.show();
      //   }
      //   let labelsMarker = new AMap.LabelMarker(obj);
      //   labelsMarker.on('click', (e) => {
      //     this.provinceListen(e);
      //   });

      //   labelsMarker.off('mouseover').on('mouseover', (e) => {
      //     let center = [data.center.lng, data.center.lat];
      //     infoWindow.open(map, center);
      //   });
      //   labelsMarker.off('mouseout').on('mouseout', (e) => {
      //     infoWindow.close();
      //   });
      //   !isSelected ? layerProvince.add(labelsMarker) : '';
      // }
      // map.add(layerProvince);
      // city ? layerProvince.hide() : '';
      // JSON.stringify;
      // console.log(disCity, 2233);
      for (let i = 0; i < cityData.length; i++) {
        isSelected = adcode && adcode == cityData[i].adcode;
        let citySearch = new AMap.DistrictSearch({
          // adcode: 440000,
          level: 'city',
          // level: "district",
          extensions: 'all',
          subdistrict: 0, //  显示下级行政区级数
        });
        if (!disCity?.length) {
          let data = cityData[i];
          // let colorArr = this.getColorByVal(data.name, false, true);
          citySearch.search(cityData[i].adcode, (status, result) => {
            if (status === 'complete') {
              let bounds = result.districtList[0].boundaries;
              if (bounds) {
                //生成行政区划polygon
                for (var j = 0; j < bounds.length; j += 1) {
                  //构造MultiPolygon的path
                  bounds[j] = [bounds[j]];
                }
                disCity[i] = new AMap.Polygon({
                  zIndex: 30,
                  strokeWeight: 1,
                  path: bounds,
                  strokeColor: '#49f3f3',
                  // fillOpacity: colorArr[1],
                  // fillColor: colorArr[0],
                  // fillColor: '#49f3f3',
                });
                map.add(disCity[i]);
                disCity[i].hide();
                this.mapObj.disCity[i] = disCity[i];

                let boxHtml = this.$u.createElm('div');
                boxHtml.appendChild(
                  this.$u.drawDialog(GisInfoBox, {
                    cityName: data.name,
                    type: 2,
                  }),
                );
                let infoWindow = new AMap.InfoWindow({
                  isCustom: true, //使用自定义窗体
                  content: boxHtml,
                  offset: new AMap.Pixel(0, -10),
                });

                disCity[i].off('mouseover').on('mouseover', (e) => {
                  // infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat]);
                  infoWindow.open(map, cityData[i].center);
                });

                infoWindow.off('mouseover').on('mouseover', (e) => {
                  // infoWindow.open(map, [e.lnglat.lng, e.lnglat.lat]);
                  infoWindow.open(map, cityData[i].center);
                });

                disCity[i].off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                infoWindow.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                disCity[i].off('click').on('click', (e) => {
                  this.$emit('mapCode', {
                    code: 440100,
                    name: data.name.split('区')[0],
                  });
                  this.cityListen(e, { infoWindow, infoWindowData: cityData[i] });
                });
              }
            }
          });
        }
        let obj = {
          ...labelObj,
          position: cityData[i].center,
        };
        obj.text.content = cityData[i].name;
        if (isSelected) {
          label.setPosition(obj.position);
          label.setText({
            content: obj.text.content,
          });
          label.show();
        }
        let labelsMarker = new AMap.LabelMarker(obj);
        labelsMarker.off('click').on('click', (e) => {
          this.$emit('mapCode', {
            code: 440100,
            name: cityData[i].name.split('区')[0],
          });
          this.cityListen(e);
        });
        !isSelected ? layerCity.add(labelsMarker) : '';
      }
      map.add(layerCity);
      // !city ? layerCity.hide() : '';
    },
    mapListen() {
      let { map, AMap } = this;
      let that = this;
      let {
        layerProvince,
        layerCity,
        disCountry,
        proOptions,
        disProvince,
        focusProvince,
        polygonCity,
        provinceData,
        label,
      } = this.mapObj;

      console.log(999, provinceData);
      map.off('complete').on('complete', function () {
        provinceData ? that.setLabels() : '';
      });

      map.off('click').on('click', (e) => {
        this.provinceListen(e);
      });
    },
    provinceListen(e) {
      let { map, AMap } = this;
      let {
        layerProvince,
        layerCity,
        disCountry,
        proOptions,
        disProvince,
        disProGuangDong,
        focusProvince,
        polygonCity,
        provinceData,
        label,
      } = this.mapObj;

      var px = e.pixel;
      var props = disProGuangDong.getDistrictByContainerPos(px);
      console.log(333, props);

      if (!props) {
        focusProvince.setDistricts('');
        focusProvince.setMap(map);
        label.hide();

        if (this.selectId === 440100) {
          if (polygonCity) {
            map.remove(polygonCity); //清除上次结果
            polygonCity = null;
          }
          this.setLabels('', true);
          // layerProvince.hide();
          // layerCity.show();
        } else {
          this.setLabels();
        }
      }

      if (props?.NAME_CHN && this.selectId === 1) {
        this.setLabels(props.adcode);
        if (props.NAME_CHN === '广州市') {
          this.selectId = 440100;
        } else {
          this.selectId = 1;
          focusProvince.setDistricts(props.adcode + '');
          focusProvince.setMap(map);
          layerProvince?.show();
          layerCity?.hide();
        }
      }

      this.$emit('mapCode', {
        code: this.selectId,
        name: this.selectId > 1 ? '' : props?.NAME_CHN,
      });
    },
    cityListen(e, infoData) {
      let { map, AMap } = this;
      let { polygonCity, layerProvince, layerCity } = this.mapObj;
      let { infoWindow, infoWindowData } = infoData;
      let geocoder = new AMap.Geocoder({
        city: '全国',
      });
      if (polygonCity) {
        map.remove(polygonCity); //清除上次结果
        polygonCity = null;
      }
      geocoder.getAddress([e.lnglat.lng, e.lnglat.lat], (status, result) => {
        if (status === 'complete' && result.regeocode) {
          let { adcode, city, citycode } = result.regeocode.addressComponent;
          adcode = `${adcode.slice(0, 4)}00`;

          let citySearch = new AMap.DistrictSearch({
            // adcode: 440100,
            // level: "province",
            level: 'district',
            extensions: 'all',
            subdistrict: 2, //  显示下级行政区级数
          });

          citySearch.search(adcode, (status, result) => {
            if (status == 'complete') {
              console.log(result, 'result');
              let bounds = result.districtList[0].boundaries;
              // 区县
              // let list = result.districtList[0].districtList;
              // list.map(item => {
              //   citySearch.search(item.name, (status1, result1) => {
              //     console.log(status1, result1)
              //   })
              // })
              if (bounds) {
                //生成行政区划polygon
                for (var i = 0; i < bounds.length; i += 1) {
                  //构造MultiPolygon的path
                  bounds[i] = [bounds[i]];
                }
                polygonCity = new AMap.Polygon({
                  strokeWeight: 1,
                  path: bounds,
                  fillOpacity: 1,
                  fillColor: '#49f3f3',
                  // fillColor: 'rgba(231, 223, 180, .8)',
                  strokeColor: '#49f3f3',
                });
                map.add(polygonCity);
                this.mapObj.polygonCity = polygonCity;

                // let boxHtml = this.$u.createElm("div");
                // boxHtml.appendChild(
                //   this.$u.drawDialog(GisInfoBox, {
                //     cityName: city
                //   })
                // );
                // let infoWindow = new AMap.InfoWindow({
                //   isCustom: true,  //使用自定义窗体
                //   content: boxHtml,
                //   offset: new AMap.Pixel(0, -10)
                // });

                if (!infoWindow) return;

                polygonCity.off('mouseover').on('mouseover', (e) => {
                  infoWindow.open(map, infoWindowData.center);
                });

                infoWindow.off('mouseover').on('mouseover', (e) => {
                  infoWindow.open(map, infoWindowData.center);
                });

                polygonCity.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });

                infoWindow.off('mouseout').on('mouseout', (e) => {
                  infoWindow.close();
                });
              }
            }
          });
          this.setLabels(adcode, true);
        }
      });
    },
  },
  mounted() {
    if (!this.linkParams.year) this.linkParams.year = new Date().getFullYear();
    this.getData();
    this.initMap();
  },
  beforeDestroy() {
    // this.map?.destory();
  },
};
</script>

<style lang="less" scoped>
.aMap {
  width: 100%;
  height: 980px;
  /*height: 100%;*/
  margin: 0;
  margin-left: 4px;
  /*transform: scale(.92);*/

  #map {
    width: 100%;
    height: 100%;
    background: transparent !important;
    position: absolute;
    top: 10px;
    left: 0;
    z-index: 1;
  }

  /deep/ .amap-logo,
  /deep/ .amap-copyright {
    display: none !important;
  }

  .map-loading {
    /*width: calc(100% + 40px);*/
    /*height: calc(100% - 100px);*/
    width: 3200px;
    height: 1080px;
    background: url('~img/home/home-bg.jpg') no-repeat;
    background-size: 100%;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: 2;
    /*backdrop-filter: blur(20px);*/

    /deep/.el-icon-loading {
      font-size: 30px;
      color: #fff;
    }
  }

  .point {
    font-size: 18px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #aafdfe;
    line-height: 43px;
    margin-top: 20px;
    margin-left: 70px;
    position: absolute;
    z-index: 2;
    .flex-center();

    /deep/.el-switch {
      width: 80px;
      position: relative;
      .el-switch__label * {
        line-height: 1;
        font-size: 14px;
        display: inline-block;
      }
      .el-switch__label {
        display: none;
        position: absolute;
        color: #fff;
        &.is-active {
          word-break: keep-all;
          display: block;
        }
      }
      .el-switch__label--right {
        z-index: 1;
        left: 5px;
      }
      /*关闭时文字位置设置*/
      .el-switch__label--left {
        /*color: #aafdfe;*/
        z-index: 1;
        right: 5px;
      }
      /*开关宽度*/
      .el-switch__core {
        color: #fff;
        width: 80px !important;

        &::after {
          border-radius: 50%;
          box-shadow: rgba(0, 0, 0, 0.1);
        }
      }
      .el-switch__core {
      }
      &.is-check {
        .el-switch__core {
          background: #aafdfe;
        }
      }
    }

    /deep/.element-select {
      height: 100%;

      .el-input__suffix,
      .el-input__suffix-inner {
        height: 100%;
        top: 50%;
        transform: translateY(-15%);
      }

      .el-select-dropdown {
        top: 229px !important;
      }
    }
  }

  .map-radio-box {
    position: absolute;
    top: 253px;
    z-index: 2;
    display: flex;
    align-items: center;

    .name {
      position: absolute;
      top: 8px;
      left: 12px;
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #aafdfe;
      line-height: 30px;
      span {
        display: inline-block;
        width: 22px;
        height: 16px;
        background: url('~img/home/map-draw.png') no-repeat;
        background-size: 100% 100%;
        margin-right: 10px;
      }
    }
    /deep/ .el-cascader {
      position: absolute;
      top: 0;
      left: 0;
      width: 300px;
      .el-input--suffix .el-input__inner {
        height: 30px;
        padding-left: 44px;
        background: linear-gradient(
          0deg,
          rgba(0, 197, 250, 0.5) 0%,
          rgba(0, 197, 250, 0.48) 6%,
          rgba(0, 197, 250, 0.11) 100%
        );
        border-radius: 3px;
        border: none;
      }
      .el-input__icon {
        position: relative;

        &.el-icon-arrow-down::before {
          position: absolute;
          top: 53%;
          transform: translateY(-55%) rotate(180deg);
          right: 5px;
          color: #fff;
          content: '';
        }

        &.el-icon-circle-close {
          /*transform: none;*/
          top: 14px;
        }

        &.is-reverse::before {
          top: 50%;
          right: 0;
        }
      }

      input {
        background: linear-gradient(
          0deg,
          rgba(0, 197, 250, 0.5) 0%,
          rgba(0, 197, 250, 0.48) 6%,
          rgba(0, 197, 250, 0.11) 100%
        );
        outline: none;
        border: none;
        color: #fff;
        font-size: 14px;
      }
    }

    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
      box-shadow: none !important;
    }

    /deep/.el-radio-group {
      margin-left: 40px;
      display: flex;
      flex-direction: column;

      .el-radio {
        color: rgba(170, 253, 254, 0.6) !important;
        line-height: 43px;
        .flex-center();

        &.is-focus {
          color: #aafdfe;
        }
      }

      .el-radio__input.is-checked {
        .el-radio__inner {
          border-color: #aafdfe;
          background-color: transparent;

          &::after {
            background: #aafdfe;
          }
        }

        + .el-radio__label {
          color: #aafdfe;
        }
      }

      .el-radio__input {
        width: 18px;
        height: 18px;
      }

      .el-radio__inner {
        width: 18px;
        height: 18px;
        border: 2px solid rgba(170, 253, 254, 0.6);
        background: transparent !important;
        box-shadow: none !important;
        border-radius: 50%;

        &:hover {
          border-color: #aafdfe !important;
        }

        &::after {
          background: transparent;
          width: 10px;
          height: 10px;
          transform: translate(-43%, -43%);
        }
      }
    }
  }

  .map-color-box {
    position: absolute;
    right: 0;
    // top: 650px;
    bottom: 43px;
    /*top: 800px;*/
    display: flex;
    flex-direction: column;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: normal;
    color: #c0c0c0;
    line-height: 24px;
    text-shadow: 0px 2px 2px rgba(16, 16, 16, 0.6);
    z-index: 2;

    .map-color {
      width: 17px;
      height: 150px;
      border: 1px solid #00c9ff;
      /*background: linear-gradient(0deg, rgba(27, 95, 152, .5) 0%, rgba(73, 243, 243, 0.75) 100%);*/
      /*background: linear-gradient(0deg, rgba(27, 95, 152, 0.5) 0%, rgba(73, 243, 243, 0.4) 100%);*/
      background: linear-gradient(0deg, #0078ff 0%, #00c9ff 36%, #58ecac 71%, #fcf5c2 100%);
      border-radius: 6px;
    }

    &::before {
      content: '单位：家';
      line-height: 30px;
    }

    // &::after {
    //   content: '低(会员总数)';
    //   line-height: 30px;
    // }

    .num-box {
      height: calc(100% - 30px);
      position: absolute;
      text-align: right;
      top: 30px;
      right: 80px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-size: 14px;
      font-family: Geometr706 BlkCn BT;
      font-weight: 900;
      color: #c0c0c0;
      line-height: 24px;
      text-shadow: 0 2px 2px rgba(16, 16, 16, 0.6);
    }
  }
  .info-box {
    position: absolute;
    right: 0;
    bottom: 83px;
    z-index: 99;
    width: max-content;
    display: flex;
    justify-content: center;
    flex-direction: column;
    text-align: left;
    i {
      position: absolute;
      left: -140px;
      width: 136px;
      height: 120px;
      display: inline-block;
      background: url('~img/market/map_icon1.png') center center no-repeat;
      background-size: cover;
      &.icon2 {
        background: url('~img/market/map_icon2.png') center center no-repeat;
        background-size: cover;
      }
      &.icon3 {
        background: url('~img/market/map_icon3.png') center center no-repeat;
        background-size: cover;
      }
      &.icon4 {
        background: url('~img/market/map_icon4.png') center center no-repeat;
        background-size: cover;
      }
    }
    h1 {
      margin: 0;
      font-family: YouSheTitle;
      font-weight: 400;
      font-size: 26px;
      color: #d8e2ff;
      line-height: 29px;
      font-style: italic;
      margin-bottom: 6px;
      // background: linear-gradient(-7deg, #f5f8ff 0.1220703125%);
      // -webkit-background-clip: text;
      // -webkit-text-fill-color: transparent;
      span {
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 14px;
        color: #d8e2ff;
        line-height: 29px;
        font-style: italic;
        margin-left: 13px;
        // background: linear-gradient(-7deg, #f5f8ff 0.1220703125%);
        opacity: 0.4;
        // -webkit-background-clip: text;
        // -webkit-text-fill-color: transparent;
      }
    }
    .num-box {
      display: flex;
      align-items: baseline;
      margin-top: 10px;
      .label {
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        font-size: 20px;
        color: #d8e2ff;
        line-height: 29px;
        font-style: italic;
        opacity: 0.85;
      }
      div.num {
        padding-right: 3px;
        font-family: Geometr706;
        font-weight: 900;
        font-size: 36px;
        color: #d8e2ff;
        line-height: 29px;
        font-style: italic;
        background: linear-gradient(0deg, #fff2b8 24.4140625%, #e1bf1f 58.88671875%, #e59e16 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
      span {
        margin-left: 17px;
        font-family: Alibaba PuHuiTi;
        font-weight: 400;
        font-size: 18px;
        color: #d8e2ff;
        line-height: 29px;
        font-style: italic;
      }
    }
  }
}
</style>
